<ng-container *ngIf="user?.profile">
  <div class="avatar" [ngStyle]="getStyle()" [ngClass]="size">
    <ng-container *ngIf="!image"><span>{{text}}</span></ng-container>
  </div>
</ng-container>
